import { BaseModel } from "../../Bases/BaseModel";

export class ConeLogisticoFiltroAcesso extends BaseModel {
  constructor(
    public regional = '',
    public operacao_id = 0,
    public origem_id = 0,
    public destino_id = 0,
    
  ) {
    super();
  }
}



